import type { Favorite } from '../../../common/schema/schemaType'

export const favoritesMem: Record<string, Favorite> = {}
